import { render, staticRenderFns } from "./tarahiSet.vue?vue&type=template&id=2eeac2ee&scoped=true"
import script from "./tarahiSet.vue?vue&type=script&lang=js"
export * from "./tarahiSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eeac2ee",
  null
  
)

export default component.exports